import React, { useState } from 'react';
import '../styles/default.scss';
import '../styles/tablet.scss';
import '../styles/desktop.scss';
import PLTable from '../../../../../../components/PL/PLTable/PLTable';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../../components/UI/UISearchBar';
import { PlusIcon } from '../../../../../../assets/icons';
import UIIconButton from '../../../../../../components/UI/UIIconButton';
import UIModal from '../../../../../../components/UI/UIModal';
import { OPTIONS_TABLE_TYPE } from '../../../../../../components/PL/PLTable/config';
import { RegionOptionsProps } from './types';
import { QUERY_LIMIT } from './config';
import { useDispatch, useSelector } from 'react-redux';
import * as strings from './strings';
import { storeSelectedOption } from '../../../../../../redux/store/options/actions';
import CreateOption from '../CreateOption';
import UILoadingPage from '../../../../../../components/UI/UILoadingPage/UILoadingPage';
import { useQuery } from 'react-apollo';
import Queries from '../../../../../../utils/API/Queries';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../../components/PL/PLTable/TypeScriptHelpers';
import { getFiltersProp } from '../../../../../../redux/selectors/CurrentUserSelectors';
import { useLocation } from 'react-router-dom';

export default function RegionOptions({ selectedRegionId }: RegionOptionsProps) {
	const dispatch = useDispatch();

	const filters = useSelector(getFiltersProp);
	const location = useLocation();

	let props = {
		filters,
		location
	};

	const baseVariables = { query: {}, isActive: true, region: selectedRegionId };
	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, OPTIONS_TABLE_TYPE, props, baseVariables);
	const { data: optionsData } = useQuery(Queries.GET_OPTIONS, { variables });

	const [showCreateOptionModal, setShowCreateOptionModal] = useState<boolean>(false);

	if (!selectedRegionId) return null;

	const setOptionsHeader = () => {
		return (
			<div className='adminRegionsPinTabs' style={{ marginTop: 12 }}>
				<UIIconButton dark icon={PlusIcon.grey} iconPadding={0} className='adminRegionsPin__addBtn' onClick={() => setShowCreateOptionModal(true)} />
				<UISearchBar
					className='adminRegionsPinTabs__searchbar'
					type={UI_SEARCH_BAR_TYPES.region}
					onSearchUpdated={() => {}}
					placeholder={strings.searchbarPlaceholder}
				/>
			</div>
		);
	};
	const renderCreateOptionModal = () => {
		const hideModal = () => setShowCreateOptionModal(false);
		return (
			<UIModal condition={showCreateOptionModal}>
				<CreateOption goBack={hideModal} onFinish={(option) => dispatch(storeSelectedOption(option))} />
			</UIModal>
		);
	};

	if (!optionsData) return <UILoadingPage />;

	return (
		<div className='adminRegions'>
			{setOptionsHeader()}
			<PLTable
				type={OPTIONS_TABLE_TYPE}
				limit={QUERY_LIMIT}
				updateTable={() => {}}
				data={optionsData.options}
				onSelect={(selectedOption) => dispatch(storeSelectedOption(selectedOption))}
			/>
			{renderCreateOptionModal()}
		</div>
	);
}
